import "reflect-metadata";
import { Container, BindingScopeEnum } from "inversify";

import IAuthenticationService from "../interfaces/authentication_service";
import IConfigurationService from "../interfaces/configuration_service";
import ITuneSelectorService from "../interfaces/tune_selector_service";
import AuthenticationService from "../services/authentication_service";
import ConfigurationService from "../services/configuration_service";
import TuneSelectorService from "../services/tune_selector_service";

export default function configureContainer(): Container 
{
	const container = new Container({ defaultScope: BindingScopeEnum.Singleton });

	container.bind<IAuthenticationService>(Symbol.for("IAuthenticationService")).to(AuthenticationService);
	container.bind<IConfigurationService>(Symbol.for("IConfigurationService")).to(ConfigurationService);
	container.bind<ITuneSelectorService>(Symbol.for("ITuneSelectorService")).to(TuneSelectorService);
	return container;
}